
import { Drawer } from "element-ui"
import drawerHeader from "./drawer-header.vue"
import countControl from "./count-control.vue"
import { COLLECT_INIT_WIDTH, GTM_FREEBLE } from "./const.js"
import slotWidget from "./slot-widget"
import { handleAddToCartV2, handleModifyCartV2 } from "@/utils/cartResponse"
import { trackViewItemList, trackSelectItem } from "@/utils/track"
export default {
  API: ["open"],
  components: {
    [Drawer.name]: Drawer,
    drawerHeader,
    slotWidget,
    countControl
  },
  inject: {
    getProId: {
      default: null
    },
    getStoreId: {
      default: null
    },
    source: {
      default: null
    }
  },
  props: {
    info: {
      type: Object,
      default: () => {}
    },
    canSelect: {
      type: Boolean,
      default: true
    },
    proId: {
      type: [String, Number],
      default: ""
    },
    storeId: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      visible: false,
      drawerSize: COLLECT_INIT_WIDTH,
      prevInfo: null
    }
  },
  computed: {
    isMax() {
      return this.info.selectedCount === this.info.maxTradeQty || !this.info.maxTradeQty
    }
  },
  watch: {
    info: {
      handler(newVal) {
        if (newVal) {
          if (this.prevInfo && JSON.stringify(this.prevInfo) !== "{}") {
            if (newVal.maxTradeQty > 0 && this.prevInfo) {
              // 前一次的dialogInfo.proNum或者dialogInfo.maxTradeQty 与当前接口返回的不相同
              if (this.prevInfo.proNum != newVal.proNum || this.prevInfo.maxTradeQty != newVal.maxTradeQty) {
                this.open()
              }
            }
          } else {
            // 第一次进入
            if (newVal.maxTradeQty && newVal.maxTradeQty != newVal.selectedCount) {
              this.open()
            }
          }
          this.prevInfo = newVal
        }
      },
      immediate: true
    }
  },
  updated() {
    if (this.info?.optItemList?.length === 0) return
    trackViewItemList(this.info.optItemList, GTM_FREEBLE, GTM_FREEBLE)
  },
  methods: {
    fen2Yuan(num) {
      if (isNaN(num)) return ""
      num = Number(num)
      return (num / 100).toFixed(2)
    },
    open() {
      this.visible = true
      this.$bus.$emit("inner-drawer", true)
    },
    handleClose() {
      this.$bus.$emit("inner-drawer", false)
      this.visible = false
    },
    async handleSelect(item, canSelect) {
      if (!canSelect) return
      const loading = this.$loading({
        background: "rgba(0, 0, 0, 0)"
      })
      const wares = [{ sku: item.skuId, beforeCount: 0, count: 1, checked: 1 }]
      const [error, data] = await handleAddToCartV2({
        storeId: this.storeId || (this.getStoreId && this.getStoreId()),
        wares,
        sort: 1,
        otherParams: {
          giftProId: this.proId || (this.getProId && this.getProId())
        }
      })
      if (error) {
        // this.$message.error(error.result)
      }
      if (data) {
        this.$bus.$emit("add-cart-success", this.source)
        if (this.source === "collect") {
          this.$bus.$emit("reload-collect")
        }
        this.count = 1
      }
      loading.close()
    },
    handleGoDetail(val) {
      val.parentId = GTM_FREEBLE
      val.layoutName = GTM_FREEBLE
      trackSelectItem(val, () => {
        this.$navigation.push(
          `${this.MAIN_ORIGIN}${this.MAIN_PATH}/p/${encodeURIComponent(val.wareName)}/i/${val.skuId}.html`
        )
      })
    }
  }
}
